import classNames from 'classnames';
import { graphql } from 'gatsby';
import React from 'react';
import ProductCard from '../components/ProductCard';

import './ProductCardSection.scss';

export const query = graphql`
	fragment ProductCardSectionFragment on Ozk_pageContent {
		product_card_grid_block {
			product_card_grid_label
			max_cards_per_row
			product_cards {
				product_name
				product_prefix
				onboard_product_param
				subheading {
					json
				}
				product_information {
					json
				}
				product_icon {
					...AssetFragment
				}
				which_button
			}
		}
	}
`;

/**
 * @typedef ProductCardBlockOptions
 * @property {'2-max' | '3-max'} max_cards_per_row
 * @property {import('../components/ProductCard').ProductCardOption[]} product_cards
 */
/**
 * @typedef ProductCardBlockProps
 * @property {import('~/contentstack/types').ModelWithLivePreviewAttr<ProductCardBlockOptions>} [options]
 */
/** @type {React.FC<ProductCardBlockProps>} */
const ProductCardSection = ({ options: { max_cards_per_row = '2-max', product_cards = [], $ } }) => {
	/** @type {(i: number) => string} */
	const isAsymmetricalCard = (i) => {
		const twoMod = product_cards.length % 2;
		const threeMod = product_cards.length % 3;

		if (max_cards_per_row === '2-max') {
			return twoMod !== 0 && i === product_cards.length - 1 ? 'asymmetrical-solo' : '';
		} else if (threeMod === 1) {
			return i === product_cards.length - 1 ? 'asymmetrical-solo' : '';
		} else if (threeMod === 2) {
			return i === product_cards.length - 2 ? 'asymmetrical-pair' : '';
		} else {
			return '';
		}
	};

	return (
		<div className="product-card-section container">
			<div
				className={classNames('product-card-container', {
					'two-max': max_cards_per_row === '2-max',
					'three-max': max_cards_per_row === '3-max',
				})}
				{...$?.max_cards_per_row}
			>
				{product_cards.map((opt, i) => (
					<ProductCard className={classNames(isAsymmetricalCard(i))} option={opt} key={i} />
				))}
			</div>
		</div>
	);
};

export default ProductCardSection;
